// extracted by mini-css-extract-plugin
module.exports = {"summary":"MealsSummery_summary__lHQP-"};